import React from 'react';
import { ANIMATE_MAP } from '@constants';
import { AnimationLayout } from '@layouts';
import { useStyles } from './styles';

const GroupedPartCard = ({
  Button,
  expanded,
  tip,
  orderedProductsList,
  isNeitherCardExpandedYet,
}) => {
  const classes = useStyles();
  const animationObjectConfig =
    expanded || isNeitherCardExpandedYet ? {} : ANIMATE_MAP.slideInDownAnimate;
  return (
    <AnimationLayout animation={animationObjectConfig}>
      <div className={classes.cardItem}>
        {tip ? (
          <div className={classes.tip}>
            <span>€</span>
            TIP{' '}
            {new Intl.NumberFormat('nl-NL', {
              style: 'currency',
              currency: 'EUR',
            }).format(tip)}
          </div>
        ) : null}
        <div className={classes.content}>
          <ul className={classes.serviceItemsList}>
            {orderedProductsList.map(productItem => (
              <li key={productItem.id}>
                {productItem.count} x {productItem.name}
              </li>
            ))}
          </ul>
          {Button}
        </div>
      </div>
    </AnimationLayout>
  );
};

export default GroupedPartCard;
